export const SliderData = [
  {
    imageUrl:
      "https://images.unsplash.com/photo-1615393911241-32add28288a5?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8bGFrZSUyMGRpc3RyaWN0fGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60",
    imageAlt: "Lake District",
  },
  {
    imageUrl:
      "https://images.unsplash.com/photo-1615393904572-b3469d50cac3?ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8bGFrZSUyMGRpc3RyaWN0fGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60",
    imageAlt: "Lake District",
  },
  {
    imageUrl:
      "https://images.unsplash.com/photo-1600185947787-ad08e1b51430?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8bGFrZSUyMGRpc3RyaWN0fGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1400&q=60",
    imageAlt: "Lake District",
  },
  {
    imageUrl:
      "https://images.unsplash.com/photo-1609511394000-2a5c8927e113?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bGFrZSUyMGRpc3RyaWN0fGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1400&q=60",
    imageAlt: "Lake District",
  },
  {
    imageUrl:
      "  https://images.unsplash.com/photo-1615393911241-32add28288a5?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2021&q=80",
    imageAlt: "Lake District",
  },
];
